import React from "react";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import { useTicketSeries } from "../../hooks/useTicketAnalytics";

const generateDemoData = () => {
  const data = [];
  let backlog = 420;
  
  for (let i = 89; i >= 0; i--) {
    const day = new Date();
    day.setDate(day.getDate() - i);
    const weekday = day.getDay();
    const base = [0.55, 0.75, 1.0, 1.1, 1.05, 0.8, 0.6][weekday];
    const opened = Math.max(5, Math.round(base * (40 + i*0.05 + (Math.random()*8-4))));
    const closed = Math.max(5, Math.round(base * (42 + i*0.03 + (Math.random()*8-4))));
    
    backlog = Math.max(0, backlog + opened - closed);
    const spikeFactor = (i < 10) ? 1.15 : 1.0;
    
    data.push({
      date: day.toISOString().slice(0, 10),
      opened: Math.round(opened * spikeFactor),
      closed: Math.round(closed),
      backlog
    });
  }
  return data;
};

export default function TicketTrendsChart() {
  const { series, loading } = useTicketSeries();
  
  const chartData = React.useMemo(() => {
    if (series?.length > 0) return series;
    return generateDemoData();
  }, [series]);
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-72 text-slate-400">
        <div className="text-center">
          <div className="w-8 h-8 mx-auto mb-2 border-2 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
          <p>Loading ticket trends…</p>
        </div>
      </div>
    );
  }
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-72 text-slate-400">
        <div className="text-center">
          <div className="w-8 h-8 mx-auto mb-2 border-2 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
          <p>Loading ticket trends…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-72 w-full p-2">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 10, right: 16, left: -12, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
          <XAxis 
            dataKey="date" 
            tick={{ fontSize: 12, fill: '#9CA3AF' }}
            stroke="#6B7280"
          />
          <YAxis 
            tick={{ fontSize: 12, fill: '#9CA3AF' }}
            stroke="#6B7280"
          />
          <Tooltip 
            contentStyle={{
              backgroundColor: '#1F2937',
              border: '1px solid #374151',
              borderRadius: '8px',
              color: '#F9FAFB'
            }}
          />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="opened" 
            stroke="#10B981" 
            strokeWidth={2}
            dot={false}
            name="Opened"
          />
          <Line 
            type="monotone" 
            dataKey="closed" 
            stroke="#3B82F6" 
            strokeWidth={2}
            dot={false}
            name="Closed"
          />
          <Line 
            type="monotone" 
            dataKey="backlog" 
            stroke="#F59E0B" 
            strokeWidth={2}
            dot={false}
            name="Backlog"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
